import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Pipe({ name: 'translateInLang', standalone: false })
export class TranslateInLangPipe implements PipeTransform {
  private static cache = new Map<string, Observable<any>>();

  constructor(private http: HttpClient) {}

  transform(key: string, lang: string, params?: { [k: string]: any }): Observable<string> {
    if (!key) {
      return of('');
    }
    const target = lang || 'en';

    if (!TranslateInLangPipe.cache.has(target)) {
      TranslateInLangPipe.cache.set(
        target,
        this.http.get(`./assets/i18n/${target}.json`).pipe(shareReplay(1))
      );
    }

    return TranslateInLangPipe.cache.get(target)!.pipe(
      map((trans) => this.resolve(trans, key, params))
    );
  }

  private resolve(trans: any, key: string, params?: { [k: string]: any }): string {
    if (!trans) {
      return key;
    }
    const parts = key.split('.');
    let val: any = trans;
    for (const part of parts) {
      if (val == null || typeof val !== 'object') {
        return key;
      }
      val = val[part];
    }
    if (typeof val !== 'string') {
      return key;
    }
    if (params) {
      val = val.replace(/\{\{\s*([^{}\s]+)\s*\}\}/g, (_: string, name: string) =>
        params[name] != null ? String(params[name]) : ''
      );
    }
    return val;
  }
}
